<template>
  <v-card v-if="loading">
    <v-skeleton-loader type="image" />
  </v-card>

  <v-card v-else flat class="card-trend d-flex" data-cy="stats-card">
    <v-card-text>
      <div v-if="isEmpty">
        <p>{{ $t('honda.dashboard.stats.no-data') }}</p>
      </div>

      <div v-else>
        <div v-if="value1 || value1 === 0" :class="`card-metric ${percent || percent === 0 ? 'no-margin' : ''}`">
          <p class="metric-title-wrapper">
            <span class="metric-title">{{ title1 }}</span>
            <span v-if="subtitle" class="metric-subtitle">{{ subtitle }}</span>
          </p>
          <p class="metric-value">{{ value1 }}</p>
        </div>

        <div v-if="(percent || percent === 0) && year" class="card-trend-data">
          <v-icon v-if="percent > 0" size="14" color="#00803f">fa-light fa-arrow-trend-up</v-icon>
          <v-icon v-if="percent < 0" size="14" color="#dc192d">fa-light fa-arrow-trend-down</v-icon>

          <span :class="`trend-${percent > 0 ? 'up' : percent < 0 ? 'down' : ''}`"
            >{{ percent > 0 ? '+' : '' }}{{ percent }}%</span
          >
          <span class="card-trend-year">{{ year - 1 }}</span>
        </div>

        <div v-if="value2 || value2 === 0" class="card-metric">
          <p class="metric-title">{{ title2 }}</p>
          <p class="metric-value">{{ value2 }}</p>
        </div>

        <div v-if="value3 || value3 === 0" class="card-metric">
          <p class="metric-title">{{ title3 }}</p>
          <p class="metric-value">{{ value3 }}</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {computed, defineComponent, toRefs} from '@vue/composition-api'

export default defineComponent({
  name: 'CardTrend',
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title1: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    value1: {
      type: [Number, String],
      required: false,
    },
    percent: {
      type: Number,
      required: false,
    },
    year: {
      type: Number,
      required: false,
    },
    title2: {
      type: String,
      required: false,
    },
    value2: {
      type: [Number, String],
      required: false,
    },
    title3: {
      type: String,
      required: false,
    },
    value3: {
      type: [Number, String],
      required: false,
    },
  },
  setup(props) {
    const {value1, value2, value3} = toRefs(props)

    const isEmpty = computed(() => {
      return (
        !(value1?.value || value1?.value === 0) &&
        !(value2?.value || value2?.value === 0) &&
        !(value3?.value || value3?.value === 0)
      )
    })

    return {
      isEmpty,
    }
  },
})
</script>

<style global>
.v-skeleton-loader__image {
  height: 270px;
}

.no-margin {
  margin: 0 !important;
}
</style>

<style lang="scss" scoped>
.card-trend {
  width: 100%;
  height: 270px;
  border-radius: 6px !important;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16) !important;
}

.card-metric {
  margin-bottom: 26px;
}

.metric-title-wrapper {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  column-gap: 5px;
  margin-bottom: 2px;
}

.metric-title {
  color: #222;
  font-family: 'ProximaNovaExCnSBold', system-ui, sans-serif;
  font-size: 20px;
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.metric-subtitle {
  color: #aaa;
  font-family: 'ProximaNovaRegular', system-ui, sans-serif;
  font-size: 14px;
  line-height: 1;
  text-transform: none;
}

.metric-value {
  display: block;
  color: #222;
  font-family: 'ProximaNovaSemibold', system-ui, sans-serif;
  font-size: 32px;
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 5px;
  min-height: 32px;
}

.card-trend-data {
  color: #888;
  font-family: 'ProximaNovaRegular', system-ui, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 20px;

  .trend-up {
    color: #00803f;
  }

  .trend-down {
    color: #dc192d;
  }

  > i {
    margin-right: 5px;
  }
}

.card-trend-year {
  font-family: 'ProximaNovaRegular', system-ui, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 5px;
}
</style>
